/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Tasks_SubtitleInputs */

const cs_pipelines_tasks_subtitle = /** @type {(inputs: Pipelines_Tasks_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrování, seznam nebo přetahování úkolů mezi fázemi.`)
};

const en_pipelines_tasks_subtitle = /** @type {(inputs: Pipelines_Tasks_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List, filter, or drag tasks between stages.`)
};

/**
* | output |
* | --- |
* | "List, filter, or drag tasks between stages." |
*
* @param {Pipelines_Tasks_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_tasks_subtitle = /** @type {((inputs?: Pipelines_Tasks_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Tasks_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_tasks_subtitle(inputs)
	return cs_pipelines_tasks_subtitle(inputs)
});